import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero/Hero';
import Footer from '../components/Footer/Footer';
import TabCards from '../components/NumbersTab/TabCards';
import Filters from '../components/NumbersTab/Filters';
import WhatsAppButton from '../components/WhatsAppButton/WhatsAppButton';
import SoldNumbersCarousel from '../components/Carousals/SoldNumbersCarousel';
import { getAllNumbers } from '../services/numberService';

function Home() {
  const [filterState, setFilterState] = useState({ network: null, category: null });
  const [allNumbers, setAllNumbers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
      const fetchAllData = async () => {
          try {
              const numbers = await getAllNumbers();
              setAllNumbers(numbers || []);
          } catch (err) {
              console.error(err);
              setError("Failed to load numbers!");
          } finally {
              setLoading(false);
          }
      };

      fetchAllData();
  }, []);

  return (
    <>
      <Hero />
      <Filters filterState={filterState} setFilterState={setFilterState} allNumbers={allNumbers} />
      <TabCards filterState={filterState} allNumbers={allNumbers} loading={loading} error={error} />
      <SoldNumbersCarousel />
      <WhatsAppButton />
      <Footer />
    </>
  );
}

export default Home;
